import React from "react";

import { Box } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  idPrefix?: string;
  tabIdPrefix?: string;
  padding?: number | string;
}

export function TabPanel({
  children,
  value,
  index,
  idPrefix = "tabpanel",
  tabIdPrefix,
  padding = 2,
  ...other
}: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${idPrefix}-${index}`}
      aria-labelledby={`${
        tabIdPrefix ?? idPrefix.replace("panel", "")
      }-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: padding }}>{children}</Box>}
    </div>
  );
}
